import * as Styled from './FloatingChatBubble.styled';

/**
 * @type {import('react').FC<{}>}
 */
const FloatingChatBubble = ({ children }) => {
  return <Styled.FloatingBubble>{children}</Styled.FloatingBubble>;
};

export default FloatingChatBubble;
